import { render } from "./Subtotal.vue?vue&type=template&id=58af2f72"
import script from "./Subtotal.vue?vue&type=script&setup=true&lang=js"
export * from "./Subtotal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/components/Subtotal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58af2f72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58af2f72', __exports__)) {
    console.log('reload')
    api.reload('58af2f72', __exports__)
  }
  
  module.hot.accept("./Subtotal.vue?vue&type=template&id=58af2f72", () => {
    console.log('re-render')
    api.rerender('58af2f72', render)
  })

}


export default __exports__